/**
 * Watchtower API client — proactive risk briefings
 */
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const BASE = `${API_BASE_URL}/api/v1/watchtower`;

export interface BriefingSummary {
  id: string;
  created_at: string;
  status: 'pending' | 'running' | 'complete' | 'error';
  title?: string | null;
  summary?: string | null;
  risk_level?: 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL' | 'UNKNOWN' | null;
  duration_ms?: number | null;
  error?: string | null;
}

export interface Briefing extends BriefingSummary {
  full_answer?: string | null;
  key_findings: string[];
  recommendations: string[];
  tool_calls: any[];
  citations: any[];
}

export interface SchedulerStatus { running: boolean; next_run: string | null; }

export const watchtowerApi = {
  list: (limit = 50) =>
    axios.get<{ briefings: BriefingSummary[] }>(`${BASE}/briefings?limit=${limit}`)
      .then(r => r.data),
  latest: () =>
    axios.get<Briefing>(`${BASE}/briefings/latest`).then(r => r.data),
  get: (id: string) =>
    axios.get<Briefing>(`${BASE}/briefings/${id}`).then(r => r.data),
  run: (company = 'Your Company', industry = 'Manufacturing', prompt?: string) =>
    axios.post<Briefing>(`${BASE}/briefings/run`,
      { company, industry, prompt, async_mode: false },
      { timeout: 180_000 }).then(r => r.data),
  remove: (id: string) =>
    axios.delete(`${BASE}/briefings/${id}`).then(r => r.data),
  schedulerStatus: () =>
    axios.get<SchedulerStatus>(`${BASE}/scheduler`).then(r => r.data),
  schedulerStart: (hour = 7, minute = 0, company = 'Your Company', industry = 'Manufacturing') =>
    axios.post(`${BASE}/scheduler/start`, { hour, minute, company, industry })
      .then(r => r.data),
  schedulerStop: () =>
    axios.post(`${BASE}/scheduler/stop`).then(r => r.data),
  pdfUrl: (id: string) => `${BASE}/briefings/${id}/pdf`,
};
